module.exports = __webpack_public_path__ + "media/images/icons/flags/BD-e438b54e9993278b3a564058e844d596.svg";